















import { Component, Vue } from "vue-property-decorator";
import components from "shared/widgets";

@Component({
  components,
})
export default class Home extends Vue {}
